import MicroModal from 'micromodal';

const drawer = () => {
  const overlay = document.querySelector('.js-drawerOverlay');
  const inner = document.querySelector('.js-drawerBody');

  MicroModal.init({
    onShow: () => {
      overlay.classList.add('is-open');
      inner.classList.add('is-open');
    },
    onClose: () => {
      overlay.classList.remove('is-open');
      inner.classList.remove('is-open');
    },
    disableScroll: true,
    debugMode: true,
  });
};

export default drawer;
